import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { derivedStatusDisplayLabel } from 'utilities/paymentsHelper';

const module = angular.module('payment-status-label', []);

interface PaymentStatusLabelController extends angular.IStrictController {
    derivedPaymentStatus: DerivedPaymentStatus;
    statusClass: string;
    statusText: string;
}

module.component('paymentStatusLabel', {
    template: template,
    bindings: {
        derivedPaymentStatus: '<'
    },
    controller: function(this: PaymentStatusLabelController) {
        const setStatusLabel = () => {
            if (this.derivedPaymentStatus) {
                this.statusText = derivedStatusDisplayLabel[this.derivedPaymentStatus];
                this.statusClass = this.derivedPaymentStatus;
            }
        };
        this.$onInit = () => {
            setStatusLabel();
        };
    }
});

export { module };
